export const btn = {
  backgroundColor: "white !important",
  border: "1px solid #4daf51",
  color: "#4daf51",
  borderRadius: "5px",
  padding: "5px",
  fontSize: "small",
  cursor: "pointer",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
  textTransform: "none",
};

export const activeBtn = {
  backgroundColor: "#4daf51 !important",
  border: "0",
  color: "white",
  padding: "5px",
  borderRadius: "5px",
  fontSize: "small",
  cursor: "pointer",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
  textTransform: "none",
};

export const ButtonList = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  rowGap: "10px",
  columnGap: "1%",
  marginBottom: "20px",
};
